module.exports = __webpack_public_path__ + "assets/img/tx101.57025419.jpg";